(() => {
  const button = document.getElementById('AenoCookiePreferences');
  const errorMessage = document.getElementById('AenoCookiePreferencesError');
  if (!button) return;

  async function getPrivacyBanner() {
    // The Shopify banner script can finish loading after the theme scripts.
    for (let attempt = 0; attempt < 100; attempt += 1) {
      if (typeof window.privacyBanner?.showPreferences === 'function') {
        return window.privacyBanner;
      }
      await new Promise((resolve) => window.setTimeout(resolve, 100));
    }
    throw new Error('Shopify privacy banner unavailable');
  }

  button.addEventListener('click', async () => {
    if (button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (errorMessage) errorMessage.hidden = true;

    try {
      const privacyBanner = await getPrivacyBanner();
      await privacyBanner.showPreferences();
    } catch {
      if (errorMessage) errorMessage.hidden = false;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
